import React, {useEffect, useState} from "react";
import {css} from "@emotion/css";
import CustomTable from "../customTable/CustomTable";
import {Box} from "@material-ui/core";
import {Pagination} from "@material-ui/lab";
import PropTypes from "prop-types";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useAuthState} from "../../context/AuthContext";
import {OtherPaymentService} from "../OtherPayments/OtherPaymentService";
import {ServerErrorHandler} from "../../service/httpClient/ServerErrorHandler";
import {convertCurrencyFormatPositiveNegative} from "../../utils/numberConvertor";
import {convertUniversalDateToPersianDate} from "../../utils/TimeConvertor";
import {checkoutStatus} from "../Checkout/CheckoutListService";

let page = 0
const AccountTransactions = ({userId}) => {

    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()
    const {token, fundID} = useAuthState()

    const service = new OtherPaymentService(fundID, token, snackbar, loading)

    const [pageCount, setPageCount] = useState(0);
    const [tableDataList, setTableDataList] = useState([]);

    useEffect(() => {
        if (typeof service !== 'undefined') {
            page = 0
            getDataFromServer()
        }
    }, [])

    function getDataFromServer() {
        loading(setLoadingStateDispatch(true))
        service.getAccountsTransactions(fundID, userId, page)
            .then(response => {
                if (response) {
                    setPageCount(response.totalPage)
                    setTableData(response.data)
                }
                loading(setLoadingStateDispatch(false))
            }).catch(reason => {
            console.log("error is ", reason)
            ServerErrorHandler(reason, "خطا در دریافت اطلاعات تراکنشات", snackbar, loading)
            loading(setLoadingStateDispatch(false))
        })
    }

    function setTableData(data) {
        setTableDataList([])
        data.map((item, index) => {
            setTableDataList(prevState => [...prevState, {
                ...item,
                number: page * 10 + index + 1,
                amount: <span
                    className={`${item.amount >= 0 ? "bg_active_state" : "bg_deActive_state"}`}>
                    {convertCurrencyFormatPositiveNegative(item.amount)}
                        </span>,
                date: convertUniversalDateToPersianDate(item.date),
                doAt: convertUniversalDateToPersianDate(item.doAt),
            }])
        })
    }


    function changePage(event, value) {
        page = value - 1
        getDataFromServer()
    }

    return (
        <div
            className={css`
              display: grid;

              flex-grow: 1;
              padding: 1rem 0;
            `}
        >
            <CustomTable
                header={columns}
                data={tableDataList}
                rowClicked={_ => {
                }}
            />
            <Box className="paginationContainer">
                <Pagination
                    count={pageCount}
                    color="primary"
                    onChange={changePage}
                    showFirstButton showLastButton/>
            </Box>
        </div>
    )
}

export default AccountTransactions;

const columns = [
    {id: 'number', label: '#', align: 'right'},
    {id: 'id', label: 'شناسه', align: 'right'},
    {id: 'kind', label: 'عنوان', align: 'right'},
    {id: 'amount', label: 'مبلغ واحد (ریال)', align: 'right'},
    {id: 'date', label: 'تاریخ', align: 'right'},
    {id: 'doAt', label: 'تاریخ ثبت', align: 'right'},
    {id: 'applicator', label: 'انجام دهنده', align: 'right'},
    {id: 'doBy', label: 'اعمال کننده', align: 'right'},
];
